import { ofType } from "redux-observable";
import { empty, merge, of } from "rxjs";
import { catchError, first, flatMap, map, switchMap } from "rxjs/operators";
import { HomeInsuranceApi } from "../../api/home-insurance.api";
import { CODES_CRM_BY_URL } from "../../constants/crm";
import ROUTES from "../../constants/routes";
import {
    disableDependentCoverages,
    loadActivePromotionDone,
    LOAD_ACTIVE_PROMOTION,
} from "../home-insurance/home-insurance.actions";
import { LOAD_PAGE, NAVIGATE_TO, OPEN_QUOTE_POPUP } from "./page.actions";
import { PageService } from "./page.service";
import { getClearPath } from "../../libs/helpers/channel";

const navigateToEpic$ = (action$, store) => {
    return action$.pipe(
        ofType(NAVIGATE_TO),
        switchMap(({ payload: page }) => {
            const {
                Page,
                HomeInsurance: {
                    quotation: { personalDataForm },
                },
            } = store.value;
            const _querystring = PageService.appendFixedPlanQueryParam({
                selectedPlanType: personalDataForm.data.planType,
                currentQueryString: Page.queryString,
                targetRoute: page,
            });
            Page.history.push({
                pathname: page,
                search: _querystring,
            });
            document.body.scrollIntoView({ behavior: "smooth" });
            return empty();
        })
    );
};

const loadPageEpic$ = (action$, store) => {
    return action$.pipe(
        ofType(LOAD_PAGE),
        switchMap(({ payload }) => {
            const { partner, partnerType } = store.value.HomeInsurance.channel;
            const clearPath = getClearPath({
                pathname: payload.originalPathname,
                partner,
                partnerType,
            });
            if (CODES_CRM_BY_URL[clearPath]) {
                return HomeInsuranceApi.sendDataCRM({
                    requestId: store.value.HomeInsurance.quotation.requestId,
                    metadata: CODES_CRM_BY_URL[payload.originalPathname],
                }).pipe(flatMap(() => empty()));
            }
            return empty();
        })
    );
};

const disableDependentCoveragesEpic$ = action$ =>
    action$.pipe(
        ofType(LOAD_PAGE),
        flatMap(({ payload: { originalPathname } }) => {
            if (originalPathname !== ROUTES.HOME_INSURANCE.STEP3) {
                return empty();
            }
            return of(disableDependentCoverages());
        })
    );

const loadActivePromotionEpic$ = action$ =>
    action$.pipe(
        ofType(OPEN_QUOTE_POPUP, LOAD_ACTIVE_PROMOTION),
        first(),
        switchMap(({ payload }) =>
            HomeInsuranceApi.getActivePromotion({ channel: payload.channel }).pipe(
                map(({ response }) => loadActivePromotionDone(response[0])),
                catchError(() => of(loadActivePromotionDone()))
            )
        )
    );

export default function pageEpics(action$, store) {
    return merge(
        navigateToEpic$(action$, store),
        loadPageEpic$(action$, store),
        disableDependentCoveragesEpic$(action$),
        loadActivePromotionEpic$(action$)
    );
}
